export default __webpack_public_path__ + "images/email_delivered-dYDkk.png";